import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/styles";
import {
  TextField, Grid, CardHeader,
  Divider, Button, Fab, Typography, CircularProgress
} from "@material-ui/core";
import PhotoCamera from "@material-ui/icons/PhotoCamera";
import SaveIcon from "@material-ui/icons/Save";
import RTL from "../../../../components/RTL";
import province from './../../../province'
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Loading, showSnackbar } from "redux/Action";
import { useDispatch, useSelector } from "react-redux";
import { axios } from "./../../../../axios";
import { values } from "underscore";
const useStyles = makeStyles((theme) => ({
  imageContainer: {
    width: 140,
    height: 140,
    margin: "auto",
    position: "relative",
    overflow: "unset",
  },
  inputBtn: {
    marginTop: theme.spacing(3),
    width: "100%",
  },
  imageButton: {
    position: "absolute",
    left: -15,
    bottom: -10,
  },
  image: {
    width: 110,
    height: 110,
  },
  input: {
    marginTop: theme.spacing(4),
    width: "100%",
  },
  imageInput: {
    display: "none",
  },
  divider: {
    opacity: "0.1",
    marginLeft: "25%",
    marginRight: "25%",
    width: "50%",
    alignItems: "center",
    backgroundColor: "#273c75",
    height: 1,
  },
  submitButtonIcon: {
    marginLeft: theme.spacing(2),
  },
  wrapper: {
    position: 'relative',
    width: '100%'
  },
  buttonProgress: {
    color: '#121E3E',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginLeft: -12,
  },
}));

const Form = (props) => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.token);
  const isLoading = useSelector(state => state.isLoading);


  var
    persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
    arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g],
    fixNumbers = function (str) {
      if (typeof str === 'string') {
        for (var i = 0; i < 10; i++) {
          str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
        }
      }
      return str;
    };


  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const { data, id, edit, reloadFunc, onClose } = props;
  const [city, setCity] = useState(edit ? data[0].driver?.city?.get_province?.name + ' ' + data[0].driver?.city?.name : null);

  const [truck, setTruck] = useState(edit ? data[0].driver?.truck_model?.truck_type?.name + ' ' + data[0].driver?.truck_model?.name : '');

  const classes = useStyles();
  const [AllTruck_types, setTruck_types] = useState([]);

  const [cities, setCities] = useState([]);
  const [error, setError] = React.useState({
    full_name: "",
    cell: "",
    city_id: "",
    truck_id: "",
  });
  const [value, setValue] = React.useState({
    full_name: edit ? data[0].full_name : "",
    cell: edit ? data[0].cell : "",
    city_id: edit ? data[0].driver?.city?.id : "",
    truck_id: edit ? data[0].driver?.truck_model?.id : "",
  });
  let id_sel_edit = edit ? data[0].city_id : "";



  const Get_Data_Sel = async () => {
    try {
      const res = await axios.get(`drivers?cell=${data[0].cell}`, {
        headers: headers,
      });

      setValue({
        ...value,
        full_name: res.data[0].data?.full_name,
        city_id: res.data.data?.company?.city?.county_id,
        truck_id: res.data.data?.company?.truck_id,
        cell: res.data[0]?.cell
      });
      // setCity(res.data.data?.company?.city?.name)

      dispatch(Loading());
    } catch (e) {
      dispatch(Loading());
    }
  }




  const Get_Component = async () => {

    try {
      const res = await axios.get('shipments/create', {
        headers: headers,
      });

      let dataCity = res.data.cities;
      let final_City = [];
      dataCity.forEach((obj, i) => {
        final_City = [
          ...final_City,
          {
            name: obj.get_province?.name + " " + obj.name,

            id: obj.id,
            province_id: obj.province_id,
            county_id: obj.county_id,
          },
        ];
      });
      setTruck_types(res.data.truck_types);

      setCities(final_City);

      if (edit) {
        // Get_Data_Sel();
        // dispatch(Loading());

      }


      // console.log(res.data.cities,"axx")
      dispatch(Loading())

    } catch (e) {
      dispatch(Loading())
      console.log(e.response, "eeeeeeeee")

    }


  }


  // useEffect(() => {

  //   if (edit &&  cities.length > 0) {
  //     let indexCitiesArr=[];
  //     Object.values(data[0].driver.cities).forEach((e)=>
  //     indexCitiesArr.push(cities.findIndex(obj =>{return obj.id == e.id}))

  //     )
          
  //     let arrrr=[];
  //     indexCitiesArr.forEach((e)=>{
  //       arrrr.push(cities[e])
  //     })

      
  //     setCity(arrrr)
  //   }


  // }, [edit, cities])


  useEffect(() => {
    Get_Component();
    dispatch(Loading());

  }, []);


  const handleChange = (e) => {
    const re = /^[0-9\b]+$/;

    let name = e.target.name;
    setError({ ...error, [name]: "" });

    switch (name) {
      case "cell":
        if (fixNumbers(e.target.value) === "" || re.test(fixNumbers(e.target.value))) {
          if (e.target.value.length < 12) {
            setValue({ ...value, [name]: fixNumbers(e.target.value) });
            setError({ ...error, [name]: "" });
          }
        } else {
          setError({ ...error, [name]: "شماره تماس فقط بصورت عدد می باشد" });
        }
        break;

      case "manager_cell":
        if (fixNumbers(e.target.value) === "" || re.test(fixNumbers(e.target.value))) {
          if (e.target.value.length < 12) {
            setValue({ ...value, [name]: fixNumbers(e.target.value) });
            setError({ ...error, [name]: "" });
          }
        } else {
          setError({ ...error, [name]: "شماره موبایل فقط بصورت عدد می باشد" });
        }
        break;



      default:
        setValue({ ...value, [name]: e.target.value });

        break;
    }


    // setValue({
    //   ...value,
    //   [event.target.name]: event.target.value,
    // });
  };

  const InsertDriver = async () => {
    // const arrCity = [];
    // arrCity.push(value.city_id)
    // value.city_id.forEach((element) => {

    //   arrCity.push(element.id);
    // });
    try {
      const res = await axios.post('drivers', {
        full_name: value.full_name,
        cell: value.cell,
        city_id: value.city_id?.id,
        truck_model_id: value.truck_id
      }, {
        headers: headers
      });
      dispatch(showSnackbar(true, 'success', 'راننده با موفقیت ثبت شد'))
      setValue({
        ...value,
        full_name: "",
        cell: "",
        city_id: "",
        truck_id: "",
      })
      setTruck("");
      setCity('');
      dispatch(Loading())

    } catch (e) {
      dispatch(Loading())
      console.log(e.response, "eeeeeeeee")
      if (e.response.status === 422) {
        const er = e.response.data.errors;

        let er_keys = Object.keys(er);
        let obj_error = {};
        er_keys.forEach((element) => {

          obj_error[element] = er[element][0];
        });

        setError(obj_error);
      }
    }


  }


  const UpdateCompany = async () => {
    const arrCity = [];
    // value.city_id.forEach((element) => {

    //   arrCity.push(element.id);
    // });
    try {
      const res = await axios.post(`drivers/${id}`, {
        full_name: value.full_name,
        cell: value.cell,
        city_id: value.city_id?.id,
        truck_model_id: value.truck_id,
        _method: 'patch'
      }, {
        headers: headers
      });
      dispatch(showSnackbar(true, 'success', 'راننده با موفقیت بروزرسانی شد'))
      setValue({
        ...value,
        full_name: "",
        cell: "",
        city_id: "",
        truck_id: "",
      })
      setCity('');
      reloadFunc();
      onClose()
      dispatch(Loading())

    } catch (e) {
      dispatch(Loading())
      console.log(e.response, "eeeeeeeee")
      if (e.response.status === 422) {
        const er = e.response.data.errors;

        let er_keys = Object.keys(er);
        let obj_error = {};
        er_keys.forEach((element) => {

          obj_error[element] = er[element][0];
        });

        setError(obj_error);
      }
    }


  }


  const sendBtn = () => {
    let va_keys = Object.keys(value);

    let obj_empty = {};
    va_keys.forEach((element) => {
      if (element == 'manager_cell') {
        if (value.manager_cell.length != 11) {
          obj_empty[element] = "تعداد ارقام شماره موبایل صحیح نمی باشد";

        }
      }
      else if (element == 'cell') {
        if (value.cell.length != 11) {
          obj_empty[element] = "تعداد ارقام شماره تماس صحیح نمی باشد";

        }
      }

      else if (value[element] === "") {
        obj_empty[element] = "این فیلد نمی تواند خالی باشد";
      }



    });


    setError(obj_empty);

    if (Object.keys(obj_empty).length == 0) {
      if (edit) {
        dispatch(Loading());
        UpdateCompany()
      } else {
        dispatch(Loading());
        InsertDriver()
      }
    }
    else {
      // alert(JSON.stringify(obj_empty))
    }
  };





  return (
    <RTL>

      {!isLoading ?
        <>
          {edit ?
            <Grid justify='center' container>

              <CardHeader title="ویرایش راننده " />
              <Divider
                className={classes.divider}
                variant="fullWidth"
              />
            </Grid>
            :
            <Grid justify='center' container>

              <CardHeader title="ثبت راننده جدید" />
              <Divider
                className={classes.divider}
                variant="fullWidth"
              />
            </Grid>}


          <Grid container justify="space-between">
            <Grid item xs={12} sm={5}>
              <TextField
                className={classes.input}
                label="نام راننده"
                variant="outlined"
                value={value.full_name}
                error={Boolean(error?.full_name)}
                helperText={(error?.full_name)}
                onChange={handleChange}
                name="full_name"

              />
            </Grid>
            <Grid item xs={12} sm={6}>
              {cities.length > 0 ?
                edit ?
                  <Autocomplete
                    // multiple
                    id="CityId"
                    noOptionsText="همچنین شهری وجود ندارد"
                    options={cities}
                    // groupBy={(option) => option.get_province?.name}

                    getOptionLabel={(option) => option.name}
                    onChange={(event, val) =>
                      val !== null
                        ? ` ${setValue({ ...value, 'city_id': val })}
                     ${setError({ ...error, city_id: "" })}`
                        :` ${setValue({ ...value, 'city_id': "" })}`
                    }
                    defaultValue={{
                      name:city ,
                    }}
                    // defaultValue={[cities[2],cities[3]]}

                  //   defaultValue={
                  
                  //   city

                  // }
                    renderInput={(params) => (
                      <TextField
                        className={classes.input}
                        {...params}
                        label="شهر محل سکونت "
                        variant="outlined"
                        error={Boolean(error?.city_id)}
                        helperText={(error?.city_id)}

                      />
                    )}
                  /> :
                  <Autocomplete
                    // multiple
                    id="CityId"
                    noOptionsText="همچنین شهری وجود ندارد"
                    options={cities}
                    // groupBy={(option) => option.get_province?.name}

                    getOptionLabel={(option) => option.name}
                    onChange={(event, val) =>
                      val !== null
                        ? ` ${setValue({ ...value, 'city_id': val })}
                     ${setError({ ...error, city_id: "" })}`
                        : ""
                    }
                    
                    renderInput={(params) => (
                      <TextField
                        className={classes.input}
                        {...params}
                        label="شهر محل سکونت "
                        variant="outlined"
                        error={Boolean(error?.city_id)}
                        helperText={(error?.city_id)}

                      />
                    )}
                  />
                : <></>}
            </Grid>



          </Grid>

          <Grid container justify="space-between">
            <Grid item xs={12} sm={5}>
              <Autocomplete
                id="TruckType"
                noOptionsText="همچنین ماشینی وجود ندارد"
                options={AllTruck_types}
                getOptionLabel={(option) => option.full_name}


                onChange={(event, val) =>
                  val !== null
                    ? ` ${setValue({ ...value, 'truck_id': val.id })} ${setTruck(val.full_name)} ${setError({ ...error, truck_id: "" })}`
                    : `${setValue({ ...value, 'truck_id': "" })} ${setTruck('')} `
                }


                value={{
                  full_name: ` ${truck
                    }`
                }}

                renderInput={(params) => (
                  <TextField
                    className={classes.input}
                    {...params}
                    label="نوع ماشین "
                    variant="outlined"
                    error={Boolean(error?.truck_id)}
                    helperText={(error?.truck_id)}

                  />
                )}
              />


            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                className={classes.input}
                label="شماره تماس راننده"
                variant="outlined"
                value={value.cell}
                error={Boolean(error?.cell)}
                helperText={(error?.cell)}
                onChange={handleChange}
                name="cell"
              />

            </Grid>
          </Grid>



          {edit ? (
            <div className={classes.wrapper}>
              <Button
                fullWidth
                className={(classes.input, classes.inputBtn)}
                variant="contained"
                color="secondary"
                disabled={isLoading}
                onClick={() => sendBtn()}

                size="large"
                startIcon={<SaveIcon className={classes.submitButtonIcon} />}
              >
                بروزرسانی راننده
              </Button>
              {isLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
            </div>
          ) : (
              <div className={classes.wrapper}>
                <Button
                  fullWidth
                  onClick={() => sendBtn()}
                  className={(classes.input, classes.inputBtn)}
                  variant="contained"
                  disabled={isLoading}

                  color="secondary"
                  size="large"
                  startIcon={<SaveIcon className={classes.submitButtonIcon} />}
                >
                  ثبت راننده جدید
              </Button>
                {isLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
              </div>
            )}

        </>
        :
        <div className={classes.wrapper} style={{ padding: 40 }}>
          {isLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
        </div>
      }
    </RTL>
  );
};

export default Form;
